import intl from "react-intl-universal";
import {
  TbAdjustmentsHorizontal,
  TbCalendar,
  TbCoin,
  TbCurrencyReal,
  TbSwitchHorizontal,
  TbUser,
} from "react-icons/tb";
import { ModernFilterBar } from "../../../../../Components/Molecules/Filters/ModernFilterBar";
import {
  AmountFilterPanel,
  CheckboxListFilterPanel,
  DateFilterPanel,
} from "../../../../../Components/Molecules/Filters/ModernFilterPanels";
import {
  EMPTY_BAAS_STABLES_FILTERS,
  buildBaasStablesFilterTags,
  getBaasStableAssetOptions,
  getBaasStableClientOptions,
  getBaasStableOperationOptions,
  getBaasStableStatusOptions,
  hasActiveBaasStablesFilters,
  isBaasStablesChipFilterActive,
  removeBaasStablesFilterTag,
} from "../baasStablesFilters";

export const BaasStablesFilterBar = ({ filters, onFiltersChange, filteredItems, transactions = [] }) => {
  const clientSource = transactions.length ? transactions : filteredItems || [];

  const filterButtons = [
    {
      id: "date",
      icon: TbCalendar,
      label: intl.get("baas.stables.filterDate"),
      active: isBaasStablesChipFilterActive(filters, "date"),
    },
    {
      id: "amount",
      icon: TbCurrencyReal,
      label: intl.get("baas.stables.filterAmount"),
      active: isBaasStablesChipFilterActive(filters, "amount"),
    },
    {
      id: "status",
      icon: TbAdjustmentsHorizontal,
      label: intl.get("baas.stables.filterStatus"),
      active: isBaasStablesChipFilterActive(filters, "status"),
    },
    {
      id: "asset",
      icon: TbCoin,
      label: intl.get("baas.stables.filterAsset"),
      active: isBaasStablesChipFilterActive(filters, "asset"),
    },
    {
      id: "operation",
      icon: TbSwitchHorizontal,
      label: intl.get("baas.stables.filterOperation"),
      active: isBaasStablesChipFilterActive(filters, "operation"),
    },
    {
      id: "client",
      icon: TbUser,
      label: intl.get("baas.stables.filterClient"),
      active: isBaasStablesChipFilterActive(filters, "client"),
    },
  ];

  const renderPanelContent = (panelId, draft, onChange) => {
    switch (panelId) {
      case "date":
        return <DateFilterPanel draft={draft} onChange={onChange} />;
      case "amount":
        return (
          <AmountFilterPanel
            draft={draft}
            onChange={onChange}
            idPrefix="baas-stables-amount"
          />
        );
      case "operation":
        return (
          <CheckboxListFilterPanel
            options={getBaasStableOperationOptions()}
            selectedValues={draft.operations}
            onChange={(operations) => onChange({ ...draft, operations })}
            idPrefix="baas-stables-operation"
          />
        );
      case "status":
        return (
          <CheckboxListFilterPanel
            options={getBaasStableStatusOptions()}
            selectedValues={draft.statuses}
            onChange={(statuses) => onChange({ ...draft, statuses })}
            idPrefix="baas-stables-status"
          />
        );
      case "asset":
        return (
          <CheckboxListFilterPanel
            options={getBaasStableAssetOptions()}
            selectedValues={draft.assets}
            onChange={(assets) => onChange({ ...draft, assets })}
            idPrefix="baas-stables-asset"
          />
        );
      case "client":
        return (
          <CheckboxListFilterPanel
            options={getBaasStableClientOptions(clientSource)}
            selectedValues={draft.clientIds}
            onChange={(clientIds) => onChange({ ...draft, clientIds })}
            idPrefix="baas-stables-client"
          />
        );
      default:
        return null;
    }
  };

  return (
    <ModernFilterBar
      filters={filters}
      onFiltersChange={onFiltersChange}
      emptyFilters={EMPTY_BAAS_STABLES_FILTERS}
      searchPlaceholder={intl.get("baas.stables.searchPlaceholder")}
      filterButtons={filterButtons}
      buildFilterTags={(currentFilters) => buildBaasStablesFilterTags(currentFilters, clientSource)}
      hasActiveFilters={hasActiveBaasStablesFilters}
      removeFilterTag={removeBaasStablesFilterTag}
      renderPanelContent={renderPanelContent}
      filteredItems={filteredItems}
      panelTitles={{
        date: intl.get("baas.stables.filterDate"),
        amount: intl.get("baas.stables.filterAmount"),
        operation: intl.get("baas.stables.filterOperation"),
        status: intl.get("baas.stables.filterStatus"),
        asset: intl.get("baas.stables.filterAsset"),
        client: intl.get("baas.stables.filterClient"),
      }}
    />
  );
};
